// Xanathar's Guide to Everything Sourcebook
// [FIX APR 2026 sub-project G]: DAMAGE_TYPES enum for condition checks below.
import { DAMAGE_TYPES } from '../../constants/enums';

export const XANATHARS_SOURCE = {
  id: 'xanathars',
  name: "Xanathar's Guide to Everything",
  author: 'Wizards of the Coast',
  version: '1.0',
  description: 'A comprehensive expansion with subclasses, spells, magic items, and tools for players and DMs',
  enabled: true,
  removable: true,
  builtin: true, // [CW-TRIO-SOURCES 2026-07-12]: shipped sourcebook — excluded from user-content listings
  categories: {
    items: true,
    spells: true,
    feats: true,
    backgrounds: false,
    subclasses: true,  // [FIX JAN 2026]: Enable subclass exposure - 30+ subclasses already defined
    abilities: true,
    boons: false
  },
  content: {
    items: {
      // Common Magic Items
      'items_boots_of_false_tracks': {
        weight: 1, size: [2, 1], baseValue: 100, icon: '👢',
        name: 'Boots of False Tracks',
        category: 'items',
        description: 'These boots leave tracks of a different humanoid of your choice.',
        equipSlot: 'feet',
        rarity: 'common'
      },
      'items_candle_of_the_deep': {
        weight: 0.5, size: [1, 1], baseValue: 50, icon: '🕯️',
        name: 'Candle of the Deep',
        category: 'items',
        description: 'This candle burns underwater and cannot be extinguished by water.',
        rarity: 'common'
      },
      'items_charlatan_die': {
        weight: 0.1, size: [1, 1], baseValue: 50, icon: '🎲',
        name: "Charlatan's Die",
        category: 'items',
        description: 'This six-sided die always rolls the number you choose.',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_cloak_of_billowing': {
        weight: 2, size: [2, 2], baseValue: 50, icon: '🦸',
        name: 'Cloak of Billowing',
        category: 'items',
        description: 'As a bonus action, this cloak dramatically billows behind you.',
        equipSlot: 'back',
        rarity: 'common'
      },
      'items_cloak_of_many_fashions': {
        weight: 2, size: [2, 2], baseValue: 100, icon: '👘',
        name: 'Cloak of Many Fashions',
        category: 'items',
        description: 'As a bonus action, change the style, color, and quality of this garment.',
        equipSlot: 'back',
        rarity: 'common'
      },
      'items_clockwork_amulet': {
        weight: 0.5, size: [1, 1], baseValue: 400, icon: '⚙️',
        name: 'Clockwork Amulet',
        category: 'items',
        description: 'Once per day, forgo rolling a d20 for an attack and get a 10 instead.',
        equipSlot: 'neck',
        rarity: 'common',
        charges: 1,
        maxCharges: 1,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_clothes_of_mending': {
        weight: 4, size: [2, 2], baseValue: 50, icon: '👔',
        name: 'Clothes of Mending',
        category: 'items',
        description: 'These clothes magically mend themselves of tears and stains.',
        rarity: 'common'
      },
      'items_dark_shard_amulet': {
        weight: 0.5, size: [1, 1], baseValue: 100, icon: '🌑',
        name: 'Dark Shard Amulet',
        category: 'items',
        description: 'While wearing this amulet, you can use an action to cast one cantrip from the warlock spell list.',
        equipSlot: 'neck',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_dread_helm': {
        weight: 3, size: [2, 2], baseValue: 150, icon: '⛑️',
        name: 'Dread Helm',
        category: 'items',
        description: 'This fearsome helm makes your eyes glow red while wearing it.',
        equipSlot: 'head',
        rarity: 'common'
      },
      'items_ear_horn_of_hearing': {
        weight: 1, size: [1, 1], baseValue: 50, icon: '📯',
        name: 'Ear Horn of Hearing',
        category: 'items',
        description: 'While held up to your ear, you have advantage on Perception checks based on hearing.',
        rarity: 'common'
      },
      'items_enduring_spellbook': {
        weight: 5, size: [2, 2], baseValue: 100, icon: '📚',
        name: 'Enduring Spellbook',
        category: 'items',
        description: 'This spellbook is immune to damage from fire and water.',
        rarity: 'common'
      },
      'items_ersatz_eye': {
        weight: 0.1, size: [1, 1], baseValue: 100, icon: '👁️',
        name: 'Ersatz Eye',
        category: 'items',
        description: 'This artificial eye replaces a lost eye and can be removed or inserted as an action.',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_hat_of_vermin': {
        weight: 1, size: [1, 1], baseValue: 100, icon: '🎩',
        name: 'Hat of Vermin',
        category: 'items',
        description: 'Three times per day, summon a bat, frog, or rat from this hat.',
        equipSlot: 'head',
        rarity: 'common',
        charges: 3,
        maxCharges: 3,
        chargesPerDay: true,
        rechargeType: 'dawn'
      },
      'items_hat_of_wizardry': {
        weight: 1, size: [1, 1], baseValue: 150, icon: '🧙',
        name: 'Hat of Wizardry',
        category: 'items',
        description: 'This pointed hat can be used as a spellcasting focus for wizard spells. You know one additional wizard cantrip.',
        equipSlot: 'head',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_hewards_handy_spice_pouch': {
        weight: 0.5, size: [1, 1], baseValue: 100, icon: '🌶️',
        name: "Heward's Handy Spice Pouch",
        category: 'items',
        description: 'This pouch produces any seasoning or spice you desire.',
        rarity: 'common'
      },
      'items_horn_of_silent_alarm': {
        weight: 1, size: [1, 1], baseValue: 150, icon: '📯',
        name: 'Horn of Silent Alarm',
        category: 'items',
        description: 'When blown, this horn alerts only those you choose within 600 feet.',
        rarity: 'common'
      },
      'items_instrument_of_illusions': {
        weight: 1, size: [2, 1], baseValue: 150, icon: '🎸',
        name: 'Instrument of Illusions',
        category: 'items',
        description: 'While playing this instrument, you can create harmless illusions within 5 feet.',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_instrument_of_scribing': {
        weight: 1, size: [2, 1], baseValue: 125, icon: '🎻',
        name: 'Instrument of Scribing',
        category: 'items',
        description: 'While playing this instrument, you can write messages that appear in the air.',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_lock_of_trickery': {
        weight: 1, size: [1, 1], baseValue: 80, icon: '🔒',
        name: 'Lock of Trickery',
        category: 'items',
        description: 'This lock opens to a key you designate, but appears to open to any other key while actually remaining locked.',
        rarity: 'common'
      },
      'items_moon_touched_sword': {
        weight: 3, size: [1, 4], baseValue: 150, icon: '🌙',
        name: 'Moon-Touched Sword',
        category: 'weapons',
        description: 'This sword sheds bright light in a 15-foot radius. Counts as magical.',
        damage: '1d8',
        damageType: 'slashing',
        properties: ['Versatile (1d10)'],
        rarity: 'common'
      },
      'items_mystery_key': {
        weight: 0.1, size: [1, 1], baseValue: 30, icon: '🗝️',
        name: 'Mystery Key',
        category: 'items',
        description: 'This key has a 5% chance of opening any lock.',
        rarity: 'common'
      },
      'items_orb_of_direction': {
        weight: 1, size: [1, 1], baseValue: 100, icon: '🧭',
        name: 'Orb of Direction',
        category: 'items',
        description: 'While holding this orb, you know which way is north.',
        equipSlot: 'mainhand',
        rarity: 'common'
      },
      'items_orb_of_time': {
        weight: 1, size: [1, 1], baseValue: 100, icon: '⏰',
        name: 'Orb of Time',
        category: 'items',
        description: 'While holding this orb, you know the exact time.',
        equipSlot: 'mainhand',
        rarity: 'common'
      },
      'items_perfume_of_bewitching': {
        weight: 0.5, size: [1, 1], baseValue: 75, icon: '🍶',
        name: 'Perfume of Bewitching',
        category: 'items',
        description: 'Gain advantage on Charisma checks for 1 hour.',
        rarity: 'common',
        charges: 3,
        maxCharges: 3,
        rechargeType: 'never'
      },
      'items_pipe_of_smoke_monsters': {
        weight: 0.5, size: [1, 1], baseValue: 120, icon: '🚬',
        name: 'Pipe of Smoke Monsters',
        category: 'items',
        description: 'Use an action to create a small smoke creature that performs a simple trick.',
        rarity: 'common'
      },
      'items_pole_of_angling': {
        weight: 4, size: [1, 5], baseValue: 75, icon: '🎣',
        name: 'Pole of Angling',
        category: 'items',
        description: 'While holding this fishing pole, you have advantage on checks to catch fish.',
        rarity: 'common'
      },
      'items_pole_of_collapsing': {
        weight: 7, size: [1, 5], baseValue: 100, icon: '📏',
        name: 'Pole of Collapsing',
        category: 'items',
        description: 'This 10-foot pole can collapse down to 1 foot as an action.',
        rarity: 'common'
      },
      'items_pot_of_awakening': {
        weight: 10, size: [2, 2], baseValue: 200, icon: '🪴',
        name: 'Pot of Awakening',
        category: 'items',
        description: 'After 30 days, a shrub planted in this pot becomes an awakened shrub.',
        rarity: 'common'
      },
      'items_rope_of_mending': {
        weight: 5, size: [2, 2], baseValue: 100, icon: '🪢',
        name: 'Rope of Mending',
        category: 'items',
        description: 'This 50-foot rope repairs itself when cut, reconnecting after 1 minute.',
        rarity: 'common'
      },
      'items_ruby_of_the_war_mage': {
        weight: 0.1, size: [1, 1], baseValue: 150, icon: '💎',
        name: 'Ruby of the War Mage',
        category: 'items',
        description: 'Attach to a weapon to use it as a spellcasting focus.',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_shield_of_expression': {
        weight: 6, size: [2, 2], baseValue: 100, icon: '😊',
        name: 'Shield of Expression',
        category: 'armor',
        description: 'The face on this shield mimics your expressions.',
        acBonus: 2,
        armorType: 'shield',
        rarity: 'common'
      },
      'items_smoldering_armor': {
        weight: 10, size: [2, 2], baseValue: 150, icon: '🔥',
        name: 'Smoldering Armor',
        category: 'armor',
        description: 'This armor smokes and smolders. You can use a bonus action to emit smoke.',
        ac: 11,
        armorType: 'light',
        rarity: 'common'
      },
      'items_staff_of_adornment': {
        weight: 4, size: [1, 5], baseValue: 50, icon: '✨',
        name: 'Staff of Adornment',
        category: 'items',
        description: 'This staff can have tiny objects float around its top.',
        equipSlot: 'mainhand',
        rarity: 'common'
      },
      'items_staff_of_birdcalls': {
        weight: 4, size: [1, 5], baseValue: 75, icon: '🐦',
        name: 'Staff of Birdcalls',
        category: 'items',
        description: 'This staff can create any bird sound.',
        equipSlot: 'mainhand',
        rarity: 'common'
      },
      'items_staff_of_flowers': {
        weight: 4, size: [1, 5], baseValue: 50, icon: '🌸',
        name: 'Staff of Flowers',
        category: 'items',
        description: 'This staff can cause flowers to bloom.',
        equipSlot: 'mainhand',
        charges: 10,
        maxCharges: 10,
        chargesPerDay: true,
        rechargeType: 'dawn',
        rarity: 'common'
      },
      'items_talking_doll': {
        weight: 0.5, size: [1, 1], baseValue: 100, icon: '🎎',
        name: 'Talking Doll',
        category: 'items',
        description: 'This doll speaks phrases when a string is pulled.',
        rarity: 'common',
        requiresAttunement: true
      },
      'items_tankard_of_sobriety': {
        weight: 1, size: [1, 1], baseValue: 100, icon: '🍺',
        name: 'Tankard of Sobriety',
        category: 'items',
        description: 'Any alcoholic beverage poured into this tankard becomes non-alcoholic.',
        rarity: 'common'
      },
      'items_unbreakable_arrow': {
        weight: 0.05, size: [1, 2], baseValue: 5, icon: '➡️',
        name: 'Unbreakable Arrow',
        category: 'ammunition',
        description: 'This arrow cannot be broken except by magic.',
        rarity: 'common'
      },
      'items_veterans_cane': {
        weight: 4, size: [1, 3], baseValue: 100, icon: '🦯',
        name: "Veteran's Cane",
        category: 'items',
        description: 'When you grasp this cane and use a bonus action, it transforms into a longsword.',
        rarity: 'common'
      },
      'items_walloping_ammunition': {
        weight: 0.05, size: [1, 2], baseValue: 25, icon: '💥',
        name: 'Walloping Ammunition',
        category: 'ammunition',
        description: 'Target must make DC 10 Strength save or be knocked prone.',
        rarity: 'common'
      },
      'items_wand_of_conducting': {
        weight: 1, size: [1, 2], baseValue: 100, icon: '🎼',
        name: 'Wand of Conducting',
        category: 'items',
        description: 'This wand can conduct orchestral music when waved.',
        equipSlot: 'mainhand',
        charges: 3,
        maxCharges: 3,
        chargesPerDay: true,
        rechargeType: 'dawn',
        rarity: 'common'
      },
      'items_wand_of_pyrotechnics': {
        weight: 1, size: [1, 2], baseValue: 125, icon: '🎆',
        name: 'Wand of Pyrotechnics',
        category: 'items',
        description: 'This wand can create harmless firework displays.',
        equipSlot: 'mainhand',
        charges: 7,
        maxCharges: 7,
        chargesPerDay: true,
        rechargeType: 'dawn',
        rarity: 'common'
      },
      'items_wand_of_scowls': {
        weight: 1, size: [1, 2], baseValue: 50, icon: '😠',
        name: 'Wand of Scowls',
        category: 'items',
        description: 'While holding this wand, you have advantage on Intimidation checks.',
        equipSlot: 'mainhand',
        rarity: 'common'
      },
      'items_wand_of_smiles': {
        weight: 1, size: [1, 2], baseValue: 50, icon: '😊',
        name: 'Wand of Smiles',
        category: 'items',
        description: 'While holding this wand, you have advantage on Persuasion checks.',
        equipSlot: 'mainhand',
        rarity: 'common'
      },
      // XGtE p.138 — Ioun Stone variants
      // [SUB-PLAN 1R / 2026-05-29]: equipSlot: 'ioun' added to all 6 rows so the
      //   InventoryContext.getEquipSlots dispatch routes via the canonical equipSlot
      //   field (no mainhand fallback). Per DMG p.176, Ioun stones float around the
      //   head — never wielded. See .claude/findings/2026-05-29-bug-A-iounStone-equipSlot-label.md
      'ioun_stone_historical_knowledge': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
        name: 'Ioun Stone of Historical Knowledge',
        category: 'items',
        rarity: 'rare',
        requiresAttunement: true,
        equipSlot: 'ioun',
        effects: [{ type: 'proficiency', operation: 'grant', value: 'skill:history', proficiencyLevel: 1 }],
        description: 'A vibrant purple prism. While orbiting your head, you gain proficiency in the History skill, or a +1 bonus to History checks if already proficient. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). XGtE p.138.'
      },
      'ioun_stone_language_knowledge': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
        name: 'Ioun Stone of Language Knowledge',
        category: 'items',
        rarity: 'rare',
        requiresAttunement: true,
        equipSlot: 'ioun',
        description: 'A bright orange prism. While orbiting your head, you can speak, read, and write one additional language (choose when you attune). Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). XGtE p.138.'
      },
      'ioun_stone_natural_knowledge': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
        name: 'Ioun Stone of Natural Knowledge',
        category: 'items',
        rarity: 'rare',
        requiresAttunement: true,
        equipSlot: 'ioun',
        effects: [{ type: 'proficiency', operation: 'grant', value: 'skill:nature', proficiencyLevel: 1 }],
        description: 'A mossy green prism. While orbiting your head, you gain proficiency in the Nature skill, or a +1 bonus to Nature checks if already proficient. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). XGtE p.138.'
      },
      'ioun_stone_religious_knowledge': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
        name: 'Ioun Stone of Religious Knowledge',
        category: 'items',
        rarity: 'rare',
        requiresAttunement: true,
        equipSlot: 'ioun',
        effects: [{ type: 'proficiency', operation: 'grant', value: 'skill:religion', proficiencyLevel: 1 }],
        description: 'A saffron prism. While orbiting your head, you gain proficiency in the Religion skill, or a +1 bonus to Religion checks if already proficient. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). XGtE p.138.'
      },
      'ioun_stone_self_preservation': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
        name: 'Ioun Stone of Self-Preservation',
        category: 'items',
        rarity: 'rare',
        requiresAttunement: true,
        equipSlot: 'ioun',
        effects: [{ type: 'save', target: 'intelligence', operation: 'add', value: 1 }],
        description: 'A silvery spindle. While orbiting your head, you gain a +1 bonus to Intelligence saving throws. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). XGtE p.138.'
      },
      // [BREADCRUMB Rule 25 — Sub-plan 1Q-F-6a 2026-05-28]: ability-check-bonus is a real D&D 5e
      //   mechanic (Ioun Stone of Supreme Intellect: +1 to Intelligence checks). No reader currently
      //   queries getEffectsForStat('abilityCheckBonus', ...). Adding the reader requires a UI surface
      //   for ability check bonuses (Skills panel currently shows skill-prof bonuses, not raw ability
      //   checks). Deferred to a future Sub-plan once the UI surface is designed. For now, the item
      //   description below truthfully states the intent; the mechanical effect is dormant.
      'ioun_stone_supreme_intellect': {
        weight: 0, size: [1, 1], baseValue: 5000, icon: '🪨',
        name: 'Ioun Stone of Supreme Intellect',
        category: 'items',
        rarity: 'rare',
        requiresAttunement: true,
        equipSlot: 'ioun',
        description: 'An iridescent spindle. While orbiting your head, you gain a +1 bonus to Intelligence checks. Three Ioun stones can orbit your head at once. An attacker can target the orbiting stone (AC 24, 10 hp, immune to all damage except force and psychic). XGtE p.138.'
      }
    },
    spells: {
      // Xanathar's Spells
      'abi_dalzims_horrid_wilting': {
        name: "Abi-Dalzim's Horrid Wilting",
        level: 8,
        school: "Necromancy",
        castTime: "1 action",
        range: "150 feet",
        components: "V, S, M (a bit of sponge)",
        duration: "Instantaneous",
        description: "30-foot cube. Creatures take 12d8 necrotic damage, plants take maximum damage.",
        damage: "12d8",
        damageType: "necrotic",
        saveType: "constitution",
        classes: ["Sorcerer", "Wizard"]
      },
      'absorb_elements': {
        name: "Absorb Elements",
        level: 1,
        school: "Abjuration",
        castTime: "1 reaction",
        range: "Self",
        components: "S",
        duration: "1 round",
        description: "Gain resistance to triggering damage type, next melee attack deals 1d6 extra damage.",
        damage: "1d6",
        damageType: "varies",
        upcastDamage: "1d6",
        classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
      },
      'aganazzars_scorcher': {
        name: "Aganazzar's Scorcher",
        level: 2,
        school: "Evocation",
        castTime: "1 action",
        range: "30 feet",
        components: "V, S, M (a red dragon's scale)",
        duration: "Instantaneous",
        description: "30-foot line of fire. Creatures take 3d8 fire damage.",
        damage: "3d8",
        damageType: "fire",
        saveType: "dexterity",
        upcastDamage: "1d8",
        classes: ["Sorcerer", "Wizard"]
      },
      'beast_bond': {
        name: "Beast Bond",
        level: 1,
        school: "Divination",
        castTime: "1 action",
        range: "Touch",
        components: "V, S, M (a bit of fur wrapped in cloth)",
        duration: "Concentration, up to 10 minutes",
        description: "Telepathic link with a beast, it has advantage on attacks against creatures within 5 feet of you.",
        classes: ["Druid", "Ranger"]
      },
      'bones_of_the_earth': {
        name: "Bones of the Earth",
        level: 6,
        school: "Transmutation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Cause up to 6 stone pillars to burst from the ground.",
        classes: ["Druid"]
      },
      'catapult': {
        name: "Catapult",
        level: 1,
        school: "Transmutation",
        castTime: "1 action",
        range: "60 feet",
        components: "S",
        duration: "Instantaneous",
        description: "Launch an object weighing 1-5 lbs. Target takes 3d8 bludgeoning damage.",
        damage: "3d8",
        damageType: "bludgeoning",
        saveType: "dexterity",
        upcastDamage: "1d8",
        classes: ["Sorcerer", "Wizard"]
      },
      'catnap': {
        name: "Catnap",
        level: 3,
        school: "Enchantment",
        castTime: "1 action",
        range: "30 feet",
        components: "S, M (a pinch of sand)",
        duration: "10 minutes",
        description: "Up to 3 willing creatures fall unconscious and gain benefits of short rest.",
        classes: ["Bard", "Sorcerer", "Wizard"]
      },
      'cause_fear': {
        name: "Cause Fear",
        level: 1,
        school: "Necromancy",
        castTime: "1 action",
        range: "60 feet",
        components: "V",
        duration: "Concentration, up to 1 minute",
        description: "One creature becomes frightened of you.",
        saveType: "wisdom",
        classes: ["Warlock", "Wizard"]
      },
      'ceremony': {
        name: "Ceremony",
        level: 1,
        school: "Abjuration (ritual)",
        castTime: "1 hour",
        range: "Touch",
        components: "V, S, M (25 gp worth of powdered silver)",
        duration: "Instantaneous",
        description: "Perform religious ceremonies with various effects.",
        classes: ["Cleric", "Paladin"]
      },
      'chaos_bolt': {
        name: "Chaos Bolt",
        level: 1,
        school: "Evocation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Ranged spell attack dealing 2d8+1d6 damage of random type. Can leap to another target.",
        damage: "2d8+1d6",
        damageType: "random",
        saveType: "attack",
        classes: ["Sorcerer"]
      },
      'charm_monster': {
        name: "Charm Monster",
        level: 4,
        school: "Enchantment",
        castTime: "1 action",
        range: "30 feet",
        components: "V, S",
        duration: "1 hour",
        description: "Charm one creature regardless of type.",
        saveType: "wisdom",
        classes: ["Bard", "Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'control_flames': {
        name: "Control Flames",
        level: 0,
        school: "Transmutation",
        castTime: "1 action",
        range: "60 feet",
        components: "S",
        duration: "Instantaneous or 1 hour",
        description: "Control nonmagical flames within a 5-foot cube.",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'control_winds': {
        name: "Control Winds",
        level: 5,
        school: "Transmutation",
        castTime: "1 action",
        range: "300 feet",
        components: "V, S",
        duration: "Concentration, up to 1 hour",
        description: "Control air in a 100-foot cube.",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'create_bonfire': {
        name: "Create Bonfire",
        level: 0,
        school: "Conjuration",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Create a bonfire in a 5-foot cube. Creatures take 1d8 fire damage.",
        damage: "1d8",
        damageType: "fire",
        saveType: "dexterity",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'create_homunculus': {
        name: "Create Homunculus",
        level: 6,
        school: "Transmutation",
        castTime: "1 hour",
        range: "Touch",
        components: "V, S, M (clay, ash, mandrake root, blood)",
        duration: "Instantaneous",
        description: "Create a tiny construct servant.",
        classes: ["Wizard"]
      },
      'crown_of_stars': {
        name: "Crown of Stars",
        level: 7,
        school: "Evocation",
        castTime: "1 action",
        range: "Self",
        components: "V, S",
        duration: "1 hour",
        description: "Seven stars orbit you. Use bonus action to launch one for 4d12 radiant damage.",
        damage: "4d12",
        damageType: "radiant",
        saveType: "attack",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'danse_macabre': {
        name: "Danse Macabre",
        level: 5,
        school: "Necromancy",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S",
        duration: "Concentration, up to 1 hour",
        description: "Animate up to 5 corpses as skeletons or zombies.",
        classes: ["Warlock", "Wizard"]
      },
      'dawn': {
        name: "Dawn",
        level: 5,
        school: "Evocation",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S, M (a sunburst pendant)",
        duration: "Concentration, up to 1 minute",
        description: "30-foot radius cylinder of sunlight. Creatures take 4d10 radiant damage.",
        damage: "4d10",
        damageType: "radiant",
        saveType: "constitution",
        classes: ["Cleric", "Wizard"]
      },
      'dragons_breath': {
        name: "Dragon's Breath",
        level: 2,
        school: "Transmutation",
        castTime: "1 bonus action",
        range: "Touch",
        components: "V, S, M (a hot pepper)",
        duration: "Concentration, up to 1 minute",
        description: "Grant creature ability to breathe 15-foot cone dealing 3d6 damage.",
        damage: "3d6",
        damageType: "varies",
        saveType: "dexterity",
        upcastDamage: "1d6",
        classes: ["Sorcerer", "Wizard"]
      },
      'druid_grove': {
        name: "Druid Grove",
        level: 6,
        school: "Abjuration",
        castTime: "10 minutes",
        range: "Touch",
        components: "V, S, M (mistletoe harvested with golden sickle)",
        duration: "24 hours",
        description: "Create a protected grove with various defensive effects.",
        classes: ["Druid"]
      },
      'dust_devil': {
        name: "Dust Devil",
        level: 2,
        school: "Conjuration",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S, M (a pinch of dust)",
        duration: "Concentration, up to 1 minute",
        description: "Create a dust devil that deals 1d8 bludgeoning damage.",
        damage: "1d8",
        damageType: "bludgeoning",
        saveType: "strength",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'earth_tremor': {
        name: "Earth Tremor",
        level: 1,
        school: "Evocation",
        castTime: "1 action",
        range: "10 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Cause tremor in 10-foot radius. Creatures take 1d6 bludgeoning and are knocked prone.",
        damage: "1d6",
        damageType: "bludgeoning",
        saveType: "dexterity",
        upcastDamage: "1d6",
        classes: ["Bard", "Druid", "Sorcerer", "Wizard"]
      },
      'earthbind': {
        name: "Earthbind",
        level: 2,
        school: "Transmutation",
        castTime: "1 action",
        range: "300 feet",
        components: "V",
        duration: "Concentration, up to 1 minute",
        description: "Yellow strips bind a flying creature, reducing its speed to 0.",
        saveType: "strength",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'elemental_bane': {
        name: "Elemental Bane",
        level: 4,
        school: "Transmutation",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Remove resistance and add 2d6 damage to attacks of chosen type.",
        damage: "2d6",
        damageType: "varies",
        saveType: "constitution",
        classes: ["Druid", "Warlock", "Wizard"]
      },
      'enemies_abound': {
        name: "Enemies Abound",
        level: 3,
        school: "Enchantment",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Creature sees all other creatures as enemies.",
        saveType: "intelligence",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
      },
      'enervation': {
        name: "Enervation",
        level: 5,
        school: "Necromancy",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Tentacle of dark energy. Target takes 4d8 necrotic, you heal half.",
        damage: "4d8",
        damageType: "necrotic",
        saveType: "dexterity",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'erupting_earth': {
        name: "Erupting Earth",
        level: 3,
        school: "Transmutation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S, M (a piece of obsidian)",
        duration: "Instantaneous",
        description: "20-foot cube erupts. Creatures take 3d12 bludgeoning damage.",
        damage: "3d12",
        damageType: "bludgeoning",
        saveType: "dexterity",
        upcastDamage: "1d12",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'far_step': {
        name: "Far Step",
        level: 5,
        school: "Conjuration",
        castTime: "1 bonus action",
        range: "Self",
        components: "V",
        duration: "Concentration, up to 1 minute",
        description: "Teleport 60 feet as bonus action each turn.",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'find_greater_steed': {
        name: "Find Greater Steed",
        level: 4,
        school: "Conjuration",
        castTime: "10 minutes",
        range: "30 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Summon a griffin, pegasus, or other flying mount.",
        classes: ["Paladin"]
      },
      'flame_arrows': {
        name: "Flame Arrows",
        level: 3,
        school: "Transmutation",
        castTime: "1 action",
        range: "Touch",
        components: "V, S",
        duration: "Concentration, up to 1 hour",
        description: "12 pieces of ammunition deal extra 1d6 fire damage.",
        damage: "1d6",
        damageType: "fire",
        classes: ["Druid", "Ranger", "Sorcerer", "Wizard"]
      },
      'frostbite': {
        name: "Frostbite",
        level: 0,
        school: "Evocation",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Target takes 1d6 cold damage and has disadvantage on next weapon attack.",
        damage: "1d6",
        damageType: "cold",
        saveType: "constitution",
        classes: ["Artificer", "Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'guardian_of_nature': {
        name: "Guardian of Nature",
        level: 4,
        school: "Transmutation",
        castTime: "1 bonus action",
        range: "Self",
        components: "V",
        duration: "Concentration, up to 1 minute",
        description: "Transform into primal beast or great tree form.",
        classes: ["Druid", "Ranger"]
      },
      'gust': {
        name: "Gust",
        level: 0,
        school: "Transmutation",
        castTime: "1 action",
        range: "30 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Push a creature 5 feet, create a small blast of air, or move a light object.",
        saveType: "strength",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'healing_spirit': {
        name: "Healing Spirit",
        level: 2,
        school: "Conjuration",
        castTime: "1 bonus action",
        range: "60 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Conjure a spirit that heals 1d6 hp to creatures that move through its space.",
        damage: "1d6",
        damageType: "healing",
        upcastDamage: "1d6",
        classes: ["Druid", "Ranger"]
      },
      'holy_weapon': {
        name: "Holy Weapon",
        level: 5,
        school: "Evocation",
        castTime: "1 bonus action",
        range: "Touch",
        components: "V, S",
        duration: "Concentration, up to 1 hour",
        description: "Weapon becomes magical, +2d8 radiant damage, sheds bright light.",
        damage: "2d8",
        damageType: "radiant",
        classes: ["Cleric", "Paladin"]
      },
      'ice_knife': {
        name: "Ice Knife",
        level: 1,
        school: "Conjuration",
        castTime: "1 action",
        range: "60 feet",
        components: "S, M (a drop of water or piece of ice)",
        duration: "Instantaneous",
        description: "Ranged attack for 1d10 piercing, then explodes for 2d6 cold in 5 feet.",
        damage: "1d10",
        damageType: "piercing",
        saveType: "attack",
        upcastDamage: "1d6",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'illusory_dragon': {
        name: "Illusory Dragon",
        level: 8,
        school: "Illusion",
        castTime: "1 action",
        range: "120 feet",
        components: "S",
        duration: "Concentration, up to 1 minute",
        description: "Create a Huge dragon illusion that can breathe 7d6 damage.",
        damage: "7d6",
        damageType: "varies",
        saveType: "intelligence",
        classes: ["Wizard"]
      },
      'immolation': {
        name: "Immolation",
        level: 5,
        school: "Evocation",
        castTime: "1 action",
        range: "90 feet",
        components: "V",
        duration: "Concentration, up to 1 minute",
        description: "Target takes 8d6 fire damage and burns for 4d6 each turn.",
        damage: "8d6",
        damageType: "fire",
        saveType: "dexterity",
        classes: ["Sorcerer", "Wizard"]
      },
      'infernal_calling': {
        name: "Infernal Calling",
        level: 5,
        school: "Conjuration",
        castTime: "1 minute",
        range: "90 feet",
        components: "V, S, M (a ruby worth at least 999 gp)",
        duration: "Concentration, up to 1 hour",
        description: "Summon a devil from the Nine Hells.",
        classes: ["Warlock", "Wizard"]
      },
      'infestation': {
        name: "Infestation",
        level: 0,
        school: "Conjuration",
        castTime: "1 action",
        range: "30 feet",
        components: "V, S, M (a living flea)",
        duration: "Instantaneous",
        description: "Target takes 1d6 poison damage and moves 5 feet randomly.",
        damage: "1d6",
        damageType: "poison",
        saveType: "constitution",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'investiture_of_flame': {
        name: "Investiture of Flame",
        level: 6,
        school: "Transmutation",
        castTime: "1 action",
        range: "Self",
        components: "V, S",
        duration: "Concentration, up to 10 minutes",
        description: "Immunity to fire, resistance to cold, emanate flames for 1d10 damage.",
        damage: "4d8",
        damageType: "fire",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'investiture_of_ice': {
        name: "Investiture of Ice",
        level: 6,
        school: "Transmutation",
        castTime: "1 action",
        range: "Self",
        components: "V, S",
        duration: "Concentration, up to 10 minutes",
        description: "Immunity to cold, resistance to fire, emanate cold for damage.",
        damage: "4d6",
        damageType: "cold",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'investiture_of_stone': {
        name: "Investiture of Stone",
        level: 6,
        school: "Transmutation",
        castTime: "1 action",
        range: "Self",
        components: "V, S",
        duration: "Concentration, up to 10 minutes",
        description: "Resistance to nonmagical physical damage, tremorsense, earth passage.",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'investiture_of_wind': {
        name: "Investiture of Wind",
        level: 6,
        school: "Transmutation",
        castTime: "1 action",
        range: "Self",
        components: "V, S",
        duration: "Concentration, up to 10 minutes",
        description: "Ranged attacks have disadvantage, fly 60 feet, cast gust of wind.",
        damage: "2d10",
        damageType: "bludgeoning",
        classes: ["Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'invulnerability': {
        name: "Invulnerability",
        level: 9,
        school: "Abjuration",
        castTime: "1 action",
        range: "Self",
        components: "V, S, M (adamantine worth 500 gp, consumed)",
        duration: "Concentration, up to 10 minutes",
        description: "Immune to all damage.",
        classes: ["Wizard"]
      },
      'life_transference': {
        name: "Life Transference",
        level: 3,
        school: "Necromancy",
        castTime: "1 action",
        range: "30 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Take 4d8 necrotic damage, heal target for twice the damage taken.",
        damage: "4d8",
        damageType: "necrotic",
        classes: ["Cleric", "Wizard"]
      },
      'maddening_darkness': {
        name: "Maddening Darkness",
        level: 8,
        school: "Evocation",
        castTime: "1 action",
        range: "150 feet",
        components: "V, M (a drop of pitch mixed with mercury)",
        duration: "Concentration, up to 10 minutes",
        description: "60-foot sphere of magical darkness, creatures inside take 8d8 psychic damage.",
        damage: "8d8",
        damageType: "psychic",
        saveType: "wisdom",
        classes: ["Warlock", "Wizard"]
      },
      'maelstrom': {
        name: "Maelstrom",
        level: 5,
        school: "Evocation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S, M (paper or leaf funnel)",
        duration: "Concentration, up to 1 minute",
        description: "30-foot radius swirling water, 6d6 bludgeoning damage.",
        damage: "6d6",
        damageType: "bludgeoning",
        saveType: "strength",
        classes: ["Druid"]
      },
      'magic_stone': {
        name: "Magic Stone",
        level: 0,
        school: "Transmutation",
        castTime: "1 bonus action",
        range: "Touch",
        components: "V, S",
        duration: "1 minute",
        description: "Enchant 3 pebbles that deal 1d6+mod bludgeoning on hit.",
        damage: "1d6",
        damageType: "bludgeoning",
        classes: ["Artificer", "Druid", "Warlock"]
      },
      'mass_polymorph': {
        name: "Mass Polymorph",
        level: 9,
        school: "Transmutation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S, M (a caterpillar cocoon)",
        duration: "Concentration, up to 1 hour",
        description: "Transform up to 10 creatures into beasts.",
        saveType: "wisdom",
        classes: ["Bard", "Sorcerer", "Wizard"]
      },
      'maximilians_earthen_grasp': {
        name: "Maximilian's Earthen Grasp",
        level: 2,
        school: "Transmutation",
        castTime: "1 action",
        range: "30 feet",
        components: "V, S, M (a miniature hand from clay)",
        duration: "Concentration, up to 1 minute",
        description: "Earth hand grapples and crushes for 2d6 bludgeoning.",
        damage: "2d6",
        damageType: "bludgeoning",
        saveType: "strength",
        classes: ["Sorcerer", "Wizard"]
      },
      'melfs_minute_meteors': {
        name: "Melf's Minute Meteors",
        level: 3,
        school: "Evocation",
        castTime: "1 action",
        range: "Self",
        components: "V, S, M (niter, sulfur, pine tar)",
        duration: "Concentration, up to 10 minutes",
        description: "Create 6 meteors, launch 2 per turn for 2d6 fire damage each.",
        damage: "2d6",
        damageType: "fire",
        saveType: "dexterity",
        classes: ["Sorcerer", "Wizard"]
      },
      'mental_prison': {
        name: "Mental Prison",
        level: 6,
        school: "Illusion",
        castTime: "1 action",
        range: "60 feet",
        components: "S",
        duration: "Concentration, up to 1 minute",
        description: "Trap creature in illusion, 5d10 psychic if save fails, 10d10 if moves.",
        damage: "5d10",
        damageType: "psychic",
        saveType: "intelligence",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'mighty_fortress': {
        name: "Mighty Fortress",
        level: 8,
        school: "Conjuration",
        castTime: "1 minute",
        range: "1 mile",
        components: "V, S, M (diamond worth 500 gp, consumed)",
        duration: "Instantaneous",
        description: "Create a stone fortress that lasts 7 days.",
        classes: ["Wizard"]
      },
      'mold_earth': {
        name: "Mold Earth",
        level: 0,
        school: "Transmutation",
        castTime: "1 action",
        range: "30 feet",
        components: "S",
        duration: "Instantaneous or 1 hour",
        description: "Move or shape earth and stone within 5 feet.",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'negative_energy_flood': {
        name: "Negative Energy Flood",
        level: 5,
        school: "Necromancy",
        castTime: "1 action",
        range: "60 feet",
        components: "V, M (a broken bone and square of black silk)",
        duration: "Instantaneous",
        description: "Target takes 5d12 necrotic. If killed, rises as zombie.",
        damage: "5d12",
        damageType: "necrotic",
        saveType: "constitution",
        classes: ["Warlock", "Wizard"]
      },
      'power_word_pain': {
        name: "Power Word: Pain",
        level: 7,
        school: "Enchantment",
        castTime: "1 action",
        range: "60 feet",
        components: "V",
        duration: "Instantaneous",
        description: "If target has 100 hp or less, incapacitated with speed of 10.",
        saveType: "constitution",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'primal_savagery': {
        name: "Primal Savagery",
        level: 0,
        school: "Transmutation",
        castTime: "1 action",
        range: "Self",
        components: "S",
        duration: "Instantaneous",
        description: "Your teeth/nails sharpen, make melee spell attack for 1d10 damage.",
        damage: "1d10",
        damageType: "acid",
        saveType: "attack",
        classes: ["Druid"]
      },
      'primordial_ward': {
        name: "Primordial Ward",
        level: 6,
        school: "Abjuration",
        castTime: "1 action",
        range: "Self",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Resistance to acid, cold, fire, lightning, and thunder damage.",
        classes: ["Druid"]
      },
      'psychic_scream': {
        name: "Psychic Scream",
        level: 9,
        school: "Enchantment",
        castTime: "1 action",
        range: "90 feet",
        components: "S",
        duration: "Instantaneous",
        description: "10 creatures take 14d6 psychic, heads explode if reduced to 0.",
        damage: "14d6",
        damageType: "psychic",
        saveType: "intelligence",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
      },
      'pyrotechnics': {
        name: "Pyrotechnics",
        level: 2,
        school: "Transmutation",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Turn fire into fireworks or smoke cloud.",
        classes: ["Bard", "Sorcerer", "Wizard"]
      },
      'scatter': {
        name: "Scatter",
        level: 6,
        school: "Conjuration",
        castTime: "1 action",
        range: "30 feet",
        components: "V",
        duration: "Instantaneous",
        description: "Teleport up to 5 creatures to different locations within 120 feet.",
        saveType: "wisdom",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'shadow_blade': {
        name: "Shadow Blade",
        level: 2,
        school: "Illusion",
        castTime: "1 bonus action",
        range: "Self",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Create shadowy blade that deals 2d8 psychic, advantage in dim/dark.",
        damage: "2d8",
        damageType: "psychic",
        upcastDamage: "1d8",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'shadow_of_moil': {
        name: "Shadow of Moil",
        level: 4,
        school: "Necromancy",
        castTime: "1 action",
        range: "Self",
        components: "V, S, M (undead eyeball in gem worth 150 gp)",
        duration: "Concentration, up to 1 minute",
        description: "Wreathed in shadows, heavily obscured, damage attackers for 2d8 necrotic.",
        damage: "2d8",
        damageType: "necrotic",
        classes: ["Warlock"]
      },
      'shape_water': {
        name: "Shape Water",
        level: 0,
        school: "Transmutation",
        castTime: "1 action",
        range: "30 feet",
        components: "S",
        duration: "Instantaneous or 1 hour",
        description: "Manipulate water within 5-foot cube.",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'sickening_radiance': {
        name: "Sickening Radiance",
        level: 4,
        school: "Evocation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S",
        duration: "Concentration, up to 10 minutes",
        description: "30-foot sphere, 4d10 radiant damage and exhaustion.",
        damage: "4d10",
        damageType: "radiant",
        saveType: "constitution",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'skill_empowerment': {
        name: "Skill Empowerment",
        level: 5,
        school: "Transmutation",
        castTime: "1 action",
        range: "Touch",
        components: "V, S",
        duration: "Concentration, up to 1 hour",
        description: "Target gains expertise in one skill.",
        classes: ["Bard", "Sorcerer", "Wizard"]
      },
      'skywrite': {
        name: "Skywrite",
        level: 2,
        school: "Transmutation (ritual)",
        castTime: "1 action",
        range: "Sight",
        components: "V, S",
        duration: "Concentration, up to 1 hour",
        description: "Write up to 10 words in clouds.",
        classes: ["Bard", "Druid", "Wizard"]
      },
      'snare': {
        name: "Snare",
        level: 1,
        school: "Abjuration",
        castTime: "1 minute",
        range: "Touch",
        components: "S, M (25 feet rope, consumed)",
        duration: "8 hours",
        description: "Create magical trap that restrains creatures.",
        saveType: "dexterity",
        classes: ["Druid", "Ranger", "Wizard"]
      },
      'snillocs_snowball_swarm': {
        name: "Snilloc's Snowball Swarm",
        level: 2,
        school: "Evocation",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (piece of ice or white rock chip)",
        duration: "Instantaneous",
        description: "5-foot radius, creatures take 3d6 cold damage.",
        damage: "3d6",
        damageType: "cold",
        saveType: "dexterity",
        upcastDamage: "1d6",
        classes: ["Sorcerer", "Wizard"]
      },
      'soul_cage': {
        name: "Soul Cage",
        level: 6,
        school: "Necromancy",
        castTime: "1 reaction",
        range: "60 feet",
        components: "V, S, M (silver cage worth 100 gp)",
        duration: "8 hours",
        description: "Trap soul of humanoid that died, use for various effects.",
        classes: ["Warlock", "Wizard"]
      },
      'steel_wind_strike': {
        name: "Steel Wind Strike",
        level: 5,
        school: "Conjuration",
        castTime: "1 action",
        range: "30 feet",
        components: "S, M (melee weapon worth 1 sp)",
        duration: "Instantaneous",
        description: "Attack up to 5 creatures for 6d10 force damage.",
        damage: "6d10",
        damageType: "force",
        saveType: "attack",
        classes: ["Ranger", "Wizard"]
      },
      'storm_sphere': {
        name: "Storm Sphere",
        level: 4,
        school: "Evocation",
        castTime: "1 action",
        range: "150 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "20-foot sphere of storms, 2d6 bludgeoning plus 4d6 lightning bolt.",
        damage: "2d6",
        damageType: "bludgeoning",
        saveType: "strength",
        classes: ["Sorcerer", "Wizard"]
      },
      'summon_greater_demon': {
        name: "Summon Greater Demon",
        level: 4,
        school: "Conjuration",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S, M (blood in vial)",
        duration: "Concentration, up to 1 hour",
        description: "Summon demon of CR 5 or lower.",
        classes: ["Warlock", "Wizard"]
      },
      'summon_lesser_demons': {
        name: "Summon Lesser Demons",
        level: 3,
        school: "Conjuration",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S, M (blood in vial)",
        duration: "Concentration, up to 1 hour",
        description: "Summon 2d4 demons of CR 1 or lower.",
        classes: ["Warlock", "Wizard"]
      },
      'synaptic_static': {
        name: "Synaptic Static",
        level: 5,
        school: "Enchantment",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "20-foot sphere, 8d6 psychic damage, -1d6 to attacks and checks.",
        damage: "8d6",
        damageType: "psychic",
        saveType: "intelligence",
        classes: ["Bard", "Sorcerer", "Warlock", "Wizard"]
      },
      'temple_of_the_gods': {
        name: "Temple of the Gods",
        level: 7,
        school: "Conjuration",
        castTime: "1 hour",
        range: "120 feet",
        components: "V, S, M (holy symbol worth 5 gp)",
        duration: "24 hours",
        description: "Create temple to your deity for 24 hours.",
        classes: ["Cleric"]
      },
      'tensers_transformation': {
        name: "Tenser's Transformation",
        level: 6,
        school: "Transmutation",
        castTime: "1 action",
        range: "Self",
        components: "V, S, M (few hairs from bull)",
        duration: "Concentration, up to 10 minutes",
        description: "Gain 50 temp hp, proficiency with weapons/armor, extra attack, advantage on attacks.",
        classes: ["Wizard"]
      },
      'thunder_step': {
        name: "Thunder Step",
        level: 3,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V",
        duration: "Instantaneous",
        description: "Teleport up to 90 feet, deal 3d10 thunder damage at origin.",
        damage: "3d10",
        damageType: "thunder",
        saveType: "constitution",
        upcastDamage: "1d10",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'thunderclap': {
        name: "Thunderclap",
        level: 0,
        school: "Evocation",
        castTime: "1 action",
        range: "5 feet",
        components: "S",
        duration: "Instantaneous",
        description: "Thunder audible 100 feet, creatures within 5 feet take 1d6 thunder.",
        damage: "1d6",
        damageType: "thunder",
        saveType: "constitution",
        classes: ["Artificer", "Bard", "Druid", "Sorcerer", "Warlock", "Wizard"]
      },
      'tidal_wave': {
        name: "Tidal Wave",
        level: 3,
        school: "Conjuration",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S, M (drop of water)",
        duration: "Instantaneous",
        description: "30x10x10 foot wave, 4d8 bludgeoning and knocked prone.",
        damage: "4d8",
        damageType: "bludgeoning",
        saveType: "dexterity",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'tiny_servant': {
        name: "Tiny Servant",
        level: 3,
        school: "Transmutation",
        castTime: "1 minute",
        range: "Touch",
        components: "V, S",
        duration: "8 hours",
        description: "Animate one tiny object as a servant.",
        classes: ["Wizard"]
      },
      'toll_the_dead': {
        name: "Toll the Dead",
        level: 0,
        school: "Necromancy",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S",
        duration: "Instantaneous",
        description: "Target takes 1d8 necrotic (1d12 if injured).",
        damage: "1d8",
        damageType: "necrotic",
        saveType: "wisdom",
        classes: ["Artificer", "Cleric", "Warlock", "Wizard"]
      },
      'transmute_rock': {
        name: "Transmute Rock",
        level: 5,
        school: "Transmutation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S, M (clay and water)",
        duration: "Until dispelled",
        description: "Turn 40-foot cube of rock to mud or mud to rock.",
        classes: ["Druid", "Wizard"]
      },
      'vitriolic_sphere': {
        name: "Vitriolic Sphere",
        level: 4,
        school: "Evocation",
        castTime: "1 action",
        range: "150 feet",
        components: "V, S, M (drop of bile)",
        duration: "Instantaneous",
        description: "20-foot sphere, 10d4 acid damage plus 5d4 next turn.",
        damage: "10d4",
        damageType: "acid",
        saveType: "dexterity",
        upcastDamage: "2d4",
        classes: ["Sorcerer", "Wizard"]
      },
      'wall_of_light': {
        name: "Wall of Light",
        level: 5,
        school: "Evocation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S, M (hand mirror)",
        duration: "Concentration, up to 10 minutes",
        description: "60x10x5 foot wall of light, 4d8 radiant and blinded.",
        damage: "4d8",
        damageType: "radiant",
        saveType: "constitution",
        classes: ["Sorcerer", "Warlock", "Wizard"]
      },
      'wall_of_sand': {
        name: "Wall of Sand",
        level: 3,
        school: "Evocation",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (handful of sand)",
        duration: "Concentration, up to 10 minutes",
        description: "30x10x10 foot wall blocks sight, slows movement.",
        classes: ["Wizard"]
      },
      'wall_of_water': {
        name: "Wall of Water",
        level: 3,
        school: "Evocation",
        castTime: "1 action",
        range: "60 feet",
        components: "V, S, M (drop of water)",
        duration: "Concentration, up to 10 minutes",
        description: "30x10x1 foot wall, ranged attacks have disadvantage through it.",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'warding_wind': {
        name: "Warding Wind",
        level: 2,
        school: "Evocation",
        castTime: "1 action",
        range: "Self",
        components: "V",
        duration: "Concentration, up to 10 minutes",
        description: "10-foot radius strong wind, difficult terrain, disadvantage on ranged attacks.",
        classes: ["Bard", "Druid", "Sorcerer", "Wizard"]
      },
      'watery_sphere': {
        name: "Watery Sphere",
        level: 4,
        school: "Conjuration",
        castTime: "1 action",
        range: "90 feet",
        components: "V, S, M (droplet of water)",
        duration: "Concentration, up to 1 minute",
        description: "10-foot sphere of water restrains creatures inside.",
        saveType: "strength",
        classes: ["Druid", "Sorcerer", "Wizard"]
      },
      'whirlwind': {
        name: "Whirlwind",
        level: 7,
        school: "Evocation",
        castTime: "1 action",
        range: "300 feet",
        components: "V, M (piece of straw)",
        duration: "Concentration, up to 1 minute",
        description: "10-foot radius, 30-foot tall cylinder, 10d6 bludgeoning.",
        damage: "10d6",
        damageType: "bludgeoning",
        saveType: "dexterity",
        classes: ["Druid", "Sorcerer"]
      },
      'word_of_radiance': {
        name: "Word of Radiance",
        level: 0,
        school: "Evocation",
        castTime: "1 action",
        range: "5 feet",
        components: "V, M (holy symbol)",
        duration: "Instantaneous",
        description: "Creatures you choose within 5 feet take 1d6 radiant.",
        damage: "1d6",
        damageType: "radiant",
        saveType: "constitution",
        classes: ["Cleric"]
      },
      'wrath_of_nature': {
        name: "Wrath of Nature",
        level: 5,
        school: "Evocation",
        castTime: "1 action",
        range: "120 feet",
        components: "V, S",
        duration: "Concentration, up to 1 minute",
        description: "Animate trees and roots in 60-foot cube to attack enemies.",
        damage: "4d6",
        damageType: "slashing",
        saveType: "dexterity",
        classes: ["Druid", "Ranger"]
      },
      'zephyr_strike': {
        name: "Zephyr Strike",
        level: 1,
        school: "Transmutation",
        castTime: "1 bonus action",
        range: "Self",
        components: "V",
        duration: "Concentration, up to 1 minute",
        description: "Move without opportunity attacks, once get advantage and +1d8 force damage.",
        damage: "1d8",
        damageType: "force",
        classes: ["Ranger"]
      }
    },
    // [PHASE 2.2 - NOV 18, 2025]: Converted all prerequisites from text to structured objects
    feats: {
      'bountiful_luck': {
        id: 'bountiful_luck',
        name: "Bountiful Luck",
        description: "Your people have extraordinary luck, which you have learned to mystically lend to your companions when you see them falter. You're not sure how you do it; you just wish it, and it happens. Surely a sign of fortune's favor!",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'halfling',
          description: "Halfling"
        },
        benefits: [
          "When an ally you can see within 30 feet of you rolls a 1 on the d20 for an attack roll, an ability check, or a saving throw, you can use your reaction to let the ally reroll the die. The ally must use the new roll.",
          "When you use this ability, you can't use your Lucky racial trait before the end of your next turn."
        ],
        // [PHASE 7.1 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        activeAbilities: {
          lendLuck: {
            name: 'Lend Luck',
            description: 'Use reaction to let ally reroll a 1 within 30 feet',
            actionType: 'reaction',
            range: 30,
            condition: {
              when: 'ally_rolls_1',
              check: (character, context) => context?.allyRoll === 1 && context?.distance <= 30
            }
          }
        },
        tags: ['support', 'luck', 'reaction', 'halfling']
      },
      'dragon_fear': {
        id: 'dragon_fear',
        name: "Dragon Fear",
        description: "When angered, you can radiate menace. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'dragonborn',
          description: "Dragonborn"
        },
        benefits: [
          "Increase your Strength, Constitution, or Charisma score by 1, to a maximum of 20.",
          "Instead of exhaling destructive energy, you can expend a use of your Breath Weapon trait to roar, forcing each creature of your choice within 30 feet of you to make a Wisdom saving throw (DC 8 + your proficiency bonus + your Charisma modifier). A target automatically succeeds on the save if it can't hear or see you. On a failed save, a target becomes frightened of you for 1 minute. If the frightened target takes any damage, it can repeat the saving throw, ending the effect on itself on a success."
        ],
        // [PHASE 7.1 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { con: 1 },
            { cha: 1 }
          ]
        },
        activeAbilities: {
          fearfulRoar: {
            name: 'Fearful Roar',
            description: 'Expend Breath Weapon to frighten creatures within 30 feet (Wisdom save)',
            actionType: 'action',
            range: 30,
            saveType: 'wisdom',
            saveDC: '8_plus_prof_plus_cha',
            duration: '1 minute',
            condition: 'frightened',
            usesBreathWeapon: true
          }
        },
        tags: ['dragonborn', 'control', 'fear', 'breath_weapon']
      },
      'dragon_hide': {
        id: 'dragon_hide',
        name: "Dragon Hide",
        description: "You manifest scales and claws reminiscent of your draconic ancestors. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'dragonborn',
          description: "Dragonborn"
        },
        benefits: [
          "Increase your Strength, Constitution, or Charisma score by 1, to a maximum of 20.",
          "Your scales harden. While you aren't wearing armor, you can calculate your AC as 13 + your Dexterity modifier. You can use a shield and still gain this benefit.",
          "You grow retractable claws from the tips of your fingers. Extending or retracting the claws requires no action. The claws are natural weapons, which you can use to make unarmed strikes. If you hit with them, you deal slashing damage equal to 1d4 + your Strength modifier, instead of the bludgeoning damage normal for an unarmed strike."
        ],
        // [PHASE 7.1 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'ac',
            operation: 'set',
            value: '13_plus_dex',
            condition: {
              when: 'not_wearing_armor',
              check: (character) => !character?.equipment?.armor
            }
          },
          {
            type: 'unarmedDamage',
            operation: 'set',
            value: '1d4',
            damageType: 'slashing',
            condition: 'always'
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { con: 1 },
            { cha: 1 }
          ]
        },
        tags: ['dragonborn', 'defensive', 'offensive', 'unarmed', 'ac']
      },
      'drow_high_magic': {
        id: 'drow_high_magic',
        name: "Drow High Magic",
        description: "You learn more of the magic typical of dark elves. You learn the detect magic spell and can cast it at will, without expending a spell slot. You also learn levitate and dispel magic, each of which you can cast once without expending a spell slot. You regain the ability to cast those two spells in this way when you finish a long rest. Charisma is your spellcasting ability for all three spells.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'elf',
          subrace: 'drow',
          description: "Elf (drow)"
        },
        benefits: [
          "You learn the detect magic spell and can cast it at will, without expending a spell slot.",
          "You also learn levitate and dispel magic, each of which you can cast once without expending a spell slot. You regain the ability to cast those two spells in this way when you finish a long rest.",
          "Charisma is your spellcasting ability for all three spells."
        ],
        // [PHASE 7.1 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        activeAbilities: {
          castDetectMagic: {
            name: 'Cast Detect Magic',
            description: 'Cast detect magic at will',
            actionType: 'action',
            usesPerDay: 'unlimited'
          },
          castLevitate: {
            name: 'Cast Levitate',
            description: 'Cast levitate once per long rest',
            usesPerLongRest: 1,
            actionType: 'action'
          },
          castDispelMagic: {
            name: 'Cast Dispel Magic',
            description: 'Cast dispel magic once per long rest',
            usesPerLongRest: 1,
            actionType: 'action'
          }
        },
        tags: ['drow', 'elf', 'magic', 'spellcasting', 'utility']
      },
      'dwarf_fortitude': {
        id: 'dwarf_fortitude',
        name: "Dwarf Fortitude",
        description: "You have the blood of dwarf heroes flowing through your veins. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'dwarf',
          description: "Dwarf"
        },
        benefits: [
          "Increase your Constitution score by 1, to a maximum of 20.",
          "Whenever you take the Dodge action in combat, you can spend one Hit Die to heal yourself. Roll the die, add your Constitution modifier, and regain a number of hit points equal to the total (minimum of 1)."
        ],
        // [PHASE 7.1 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          con: 1
        },
        activeAbilities: {
          healingDodge: {
            name: 'Healing Dodge',
            description: 'When you Dodge, spend one Hit Die to heal yourself',
            actionType: 'combined',
            requiresAction: 'dodge',
            usesHitDie: true
          }
        },
        tags: ['dwarf', 'defensive', 'healing', 'combat']
      },
      'elven_accuracy': {
        id: 'elven_accuracy',
        name: "Elven Accuracy",
        description: "The accuracy of elves is legendary, especially that of elf archers and spellcasters. You have uncanny aim with attacks that rely on precision rather than brute force. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: ['elf', 'half-elf'],
          description: "Elf or half-elf"
        },
        benefits: [
          "Increase your Dexterity, Intelligence, Wisdom, or Charisma score by 1, to a maximum of 20.",
          "Whenever you have advantage on an attack roll using Dexterity, Intelligence, Wisdom, or Charisma, you can reroll one of the dice once."
        ],
        // [PHASE 7.2 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'feature',
            operation: 'grant',
            value: 'reroll_advantage_die',
            condition: {
              when: 'advantage_attack_mental_stats',
              check: (character, context) => {
                return context?.hasAdvantage === true &&
                       context?.attackStat &&
                       ['dex', 'int', 'wis', 'cha'].includes(context.attackStat);
              }
            }
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { dex: 1 },
            { int: 1 },
            { wis: 1 },
            { cha: 1 }
          ]
        },
        tags: ['elf', 'half-elf', 'offensive', 'accuracy', 'advantage']
      },
      'fade_away': {
        id: 'fade_away',
        name: "Fade Away",
        description: "Your people are clever, with a knack for illusion magic. You have learned a magical trick for fading away when you suffer harm. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'gnome',
          description: "Gnome"
        },
        benefits: [
          "Increase your Dexterity or Intelligence score by 1, to a maximum of 20.",
          "Immediately after you take damage, you can use a reaction to magically become invisible until the end of your next turn or until you attack, deal damage, or force someone to make a saving throw. Once you use this ability, you can't do so again until you finish a short or long rest."
        ],
        // [PHASE 7.2 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { dex: 1 },
            { int: 1 }
          ]
        },
        activeAbilities: {
          fadeAway: {
            name: 'Fade Away',
            description: 'When you take damage, use reaction to become invisible until end of your next turn',
            actionType: 'reaction',
            usesPerShortRest: 1,
            condition: {
              when: 'take_damage',
              check: (character, context) => context?.tookDamage === true
            },
            duration: 'end_of_next_turn',
            endsOn: ['attack', 'deal_damage', 'force_save']
          }
        },
        tags: ['gnome', 'defensive', 'utility', 'invisibility', 'reaction']
      },
      'fey_teleportation': {
        id: 'fey_teleportation',
        name: "Fey Teleportation",
        description: "Your study of high elven lore has unlocked fey power that few other elves possess, except your eladrin cousins. Drawing on your fey ancestry, you can momentarily stride through the Feywild to shorten your path from one place to another. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'elf',
          subrace: 'high',
          description: "Elf (high elf)"
        },
        benefits: [
          "Increase your Intelligence or Charisma score by 1, to a maximum of 20.",
          "You learn to speak, read, and write Sylvan.",
          "You learn the misty step spell and can cast it once without expending a spell slot. You regain the ability to cast it in this way when you finish a short or long rest. Intelligence is your spellcasting ability for this spell."
        ],
        // [PHASE 7.2 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'proficiency',
            target: 'language',
            value: 'sylvan',
            operation: 'add',
            condition: 'always'
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { int: 1 },
            { cha: 1 }
          ]
        },
        activeAbilities: {
          castMistyStep: {
            name: 'Cast Misty Step',
            description: 'Cast misty step once per short or long rest',
            usesPerShortRest: 1,
            actionType: 'bonus'
          }
        },
        tags: ['elf', 'high-elf', 'magic', 'teleportation', 'mobility', 'spellcasting']
      },
      'flames_of_phlegethos': {
        id: 'flames_of_phlegethos',
        name: "Flames of Phlegethos",
        description: "You learn to call on hellfire to serve your commands. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'tiefling',
          description: "Tiefling"
        },
        benefits: [
          "Increase your Intelligence or Charisma score by 1, to a maximum of 20.",
          "When you roll fire damage for a spell you cast, you can reroll any roll of 1 on the fire damage dice, but you must use the new roll, even if it is another 1.",
          "Whenever you cast a spell that deals fire damage, you can cause flames to wreathe you until the end of your next turn. The flames don't harm you or your possessions, and they shed bright light in a 30-foot radius and dim light for an additional 30 feet. While the flames are present, any creature within 5 feet of you that hits you with a melee attack takes 1d4 fire damage."
        ],
        // [PHASE 7.2 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'feature',
            operation: 'grant',
            value: 'reroll_fire_damage_1s',
            condition: {
              when: 'fire_spell_damage',
              check: (character, context) => context?.damageType === DAMAGE_TYPES.FIRE && context?.isSpell === true
            }
          },
          {
            type: 'feature',
            operation: 'grant',
            value: 'flaming_aura_on_fire_spell',
            condition: {
              when: 'cast_fire_spell',
              check: (character, context) => context?.damageType === DAMAGE_TYPES.FIRE && context?.casting === true
            }
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { int: 1 },
            { cha: 1 }
          ]
        },
        tags: ['tiefling', 'magic', 'fire', 'offensive', 'defensive', 'spellcasting']
      },
      'infernal_constitution': {
        id: 'infernal_constitution',
        name: "Infernal Constitution",
        description: "Fiendish blood runs strong in you, unlocking a resilience akin to that possessed by some fiends. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'tiefling',
          description: "Tiefling"
        },
        benefits: [
          "Increase your Constitution score by 1, to a maximum of 20.",
          "You have resistance to cold damage and poison damage.",
          "You have advantage on saving throws against being poisoned."
        ],
        // [PHASE 7.2 - NOV 18, 2025]: Full implementation with unified effects schema
        // [Sub-plan 1I(i) 2026-05-26]: split from one row with `value:['cold','poison']`
        //   to two separate per-damage-type rows. The reader at
        //   effectCalculator.getDamageResistances L2967-2970 does
        //   `resistances.add(effect.value)` — array values were added as a
        //   single Set entry rather than iterated. SRD writer convention
        //   (e.g., Bear Totem at srdSubclassFeatures.js L86-97) is one row per
        //   damage type; this row now matches.
        effects: [
          {
            type: 'resistance',
            operation: 'grant',
            value: 'cold',
            condition: 'always'
          },
          {
            type: 'resistance',
            operation: 'grant',
            value: 'poison',
            condition: 'always'
          },
          {
            type: 'advantage',
            target: 'poisoned',
            operation: 'grant',
            value: true,
            condition: {
              when: 'saving_throw_poison',
              check: (character, context) => context?.saveType === 'poisoned'
            }
          }
        ],
        abilityScoreIncrease: {
          con: 1
        },
        tags: ['tiefling', 'defensive', 'resistance', 'constitution']
      },
      'orcish_fury': {
        id: 'orcish_fury',
        name: "Orcish Fury",
        description: "Your inner fury burns tirelessly. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'half-orc',
          description: "Half-orc"
        },
        benefits: [
          "Increase your Strength or Constitution score by 1, to a maximum of 20.",
          "When you hit with an attack using a simple or martial weapon, you can roll one of the weapon's damage dice an additional time and add it as extra damage of the weapon's damage type. Once you use this ability, you can't use it again until you finish a short or long rest.",
          "Immediately after you use your Relentless Endurance trait, you can use your reaction to make one weapon attack."
        ],
        // [PHASE 7.3 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { con: 1 }
          ]
        },
        activeAbilities: {
          furiousCritical: {
            name: 'Furious Critical',
            description: 'Add one weapon damage die to attack damage',
            usesPerShortRest: 1,
            actionType: 'passive',
            condition: {
              when: 'weapon_hit',
              check: (character, context) => context?.weaponHit === true
            }
          },
          relentlessRetaliation: {
            name: 'Relentless Retaliation',
            description: 'After using Relentless Endurance, make one weapon attack as a reaction',
            actionType: 'reaction',
            condition: {
              when: 'used_relentless_endurance',
              check: (character, context) => context?.usedRelentlessEndurance === true
            }
          }
        },
        tags: ['half-orc', 'offensive', 'combat', 'reaction']
      },
      'prodigy': {
        id: 'prodigy',
        name: "Prodigy",
        description: "You have a knack for learning new things. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: ['half-elf', 'half-orc', 'human'],
          description: "Half-elf, half-orc, or human"
        },
        benefits: [
          "You gain one skill proficiency of your choice, one tool proficiency of your choice, and fluency in one language of your choice.",
          "Choose one skill in which you have proficiency. You gain expertise with that skill, which means your proficiency bonus is doubled for any ability check you make with it. The skill you choose must be one that isn't already benefiting from a feature, such as Expertise, that doubles your proficiency bonus."
        ],
        // [PHASE 7.3 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        customChoices: {
          skillProficiency: {
            choose: 1,
            from: 'all_skills'
          },
          toolProficiency: {
            choose: 1,
            from: 'all_tools'
          },
          language: {
            choose: 1,
            from: 'all_languages'
          },
          skillExpertise: {
            choose: 1,
            from: 'proficient_skills'
          }
        },
        tags: ['utility', 'skill', 'expertise', 'versatile']
      },
      'second_chance': {
        id: 'second_chance',
        name: "Second Chance",
        description: "Fortune favors you when someone tries to strike you. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'halfling',
          description: "Halfling"
        },
        benefits: [
          "Increase your Dexterity, Constitution, or Charisma score by 1, to a maximum of 20.",
          "When a creature you can see hits you with an attack roll, you can use your reaction to force that creature to reroll. Once you use this ability, you can't use it again until you roll initiative at the start of combat or until you finish a short or long rest."
        ],
        // [PHASE 7.3 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        abilityScoreIncrease: {
          choice: [
            { dex: 1 },
            { con: 1 },
            { cha: 1 }
          ]
        },
        activeAbilities: {
          forceReroll: {
            name: 'Second Chance',
            description: 'Force attacker to reroll their attack against you',
            actionType: 'reaction',
            usesPerCombat: 1,
            condition: {
              when: 'hit_by_attack',
              check: (character, context) => context?.wasHit === true && context?.canSeeAttacker === true
            }
          }
        },
        tags: ['halfling', 'defensive', 'luck', 'reaction']
      },
      'squat_nimbleness': {
        id: 'squat_nimbleness',
        name: "Squat Nimbleness",
        description: "You are uncommonly nimble for your race. You gain the following benefits.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'dwarf',
          description: "Dwarf or a Small race"
        },
        benefits: [
          "Increase your Strength or Dexterity score by 1, to a maximum of 20.",
          "Increase your walking speed by 5 feet.",
          "You gain proficiency in the Acrobatics or Athletics skill (your choice). If you are already proficient in the skill, you add double your proficiency bonus to checks you make with it."
        ],
        // [PHASE 7.3 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [
          {
            type: 'speed',
            operation: 'add',
            value: 5,
            condition: 'always'
          }
        ],
        abilityScoreIncrease: {
          choice: [
            { str: 1 },
            { dex: 1 }
          ]
        },
        customChoices: {
          skillProficiencyOrExpertise: {
            choose: 1,
            from: ['acrobatics', 'athletics'],
            grantExpertiseIfProficient: true
          }
        },
        tags: ['dwarf', 'small', 'mobility', 'skill', 'athletics']
      },
      'wood_elf_magic': {
        id: 'wood_elf_magic',
        name: "Wood Elf Magic",
        description: "You learn the magic of the primeval woods, which are revered and protected by your people. You learn one druid cantrip of your choice. You also learn the longstrider and pass without trace spells, each of which you can cast once without expending a spell slot. You regain the ability to cast these two spells in this way when you finish a long rest. Wisdom is your spellcasting ability for all three spells.",
        source: "Xanathar's Guide to Everything",
        prerequisites: {
          race: 'elf',
          subrace: 'wood',
          description: "Elf (wood elf)"
        },
        benefits: [
          "You learn one druid cantrip of your choice.",
          "You also learn the longstrider and pass without trace spells, each of which you can cast once without expending a spell slot. You regain the ability to cast these two spells in this way when you finish a long rest.",
          "Wisdom is your spellcasting ability for all three spells."
        ],
        // [PHASE 7.3 - NOV 18, 2025]: Full implementation with unified effects schema
        effects: [],
        customChoices: {
          cantrip: {
            choose: 1,
            from: 'druid_cantrips'
          }
        },
        activeAbilities: {
          castLongstrider: {
            name: 'Cast Longstrider',
            description: 'Cast longstrider once per long rest',
            usesPerLongRest: 1,
            actionType: 'action'
          },
          castPassWithoutTrace: {
            name: 'Cast Pass Without Trace',
            description: 'Cast pass without trace once per long rest',
            usesPerLongRest: 1,
            actionType: 'action'
          }
        },
        tags: ['elf', 'wood-elf', 'magic', 'utility', 'stealth', 'spellcasting']
      }
    },
    abilities: {
      // Xanathar's Optional Class Features
      'arcane_archer_lore': {
        name: "Arcane Archer Lore",
        description: "Fighter (Arcane Archer): Gain proficiency in Arcana or Nature, and learn prestidigitation or druidcraft.",
        class: "Fighter",
        level: 3
      },
      'path_of_the_ancestral_guardian': {
        name: "Path of the Ancestral Guardian",
        description: "Barbarian: Spectral warriors aid you in battle, hindering enemies that attack allies.",
        class: "Barbarian",
        level: 3
      },
      'path_of_the_storm_herald': {
        name: "Path of the Storm Herald",
        description: "Barbarian: Emanate a storm aura (desert, sea, or tundra) while raging.",
        class: "Barbarian",
        level: 3
      },
      'path_of_the_zealot': {
        name: "Path of the Zealot",
        description: "Barbarian: Channel divine fury, deal extra damage and be raised from dead without material components.",
        class: "Barbarian",
        level: 3
      },
      'college_of_glamour': {
        name: "College of Glamour",
        description: "Bard: Weave fey magic into performances, charm and beguile audiences.",
        class: "Bard",
        level: 3
      },
      'college_of_swords': {
        name: "College of Swords",
        description: "Bard: Master of blade work, use weapons as spellcasting focuses and gain blade flourishes.",
        class: "Bard",
        level: 3
      },
      'college_of_whispers': {
        name: "College of Whispers",
        description: "Bard: Master of secrets and psychological warfare, deal psychic damage and steal identities.",
        class: "Bard",
        level: 3
      },
      'forge_domain': {
        name: "Forge Domain",
        description: "Cleric: Gods of forge and creation grant heavy armor, smith's tools, and ability to imbue items.",
        class: "Cleric",
        level: 1
      },
      'grave_domain': {
        name: "Grave Domain",
        description: "Cleric: Watch over the line between life and death, cancel critical hits and maximize healing.",
        class: "Cleric",
        level: 1
      },
      'circle_of_dreams': {
        name: "Circle of Dreams",
        description: "Druid: Connected to Feywild, provide healing and rest to allies.",
        class: "Druid",
        level: 2
      },
      'circle_of_the_shepherd': {
        name: "Circle of the Shepherd",
        description: "Druid: Commune with spirits of nature, summon spirit totems and speak with beasts.",
        class: "Druid",
        level: 2
      },
      'arcane_archer': {
        name: "Arcane Archer",
        description: "Fighter: Weave magic into archery, imbue arrows with magical effects.",
        class: "Fighter",
        level: 3
      },
      'cavalier': {
        name: "Cavalier",
        description: "Fighter: Master of mounted combat, protect allies and control battlefield.",
        class: "Fighter",
        level: 3
      },
      'samurai': {
        name: "Samurai",
        description: "Fighter: Resolve grants advantage and temporary hit points through fighting spirit.",
        class: "Fighter",
        level: 3
      },
      'way_of_the_drunken_master': {
        name: "Way of the Drunken Master",
        description: "Monk: Unpredictable movement, redirect attacks and move through combat freely.",
        class: "Monk",
        level: 3
      },
      'way_of_the_kensei': {
        name: "Way of the Kensei",
        description: "Monk: Master specific weapons as extensions of your body.",
        class: "Monk",
        level: 3
      },
      'way_of_the_sun_soul': {
        name: "Way of the Sun Soul",
        description: "Monk: Channel inner light as radiant sun bolts and burning hands.",
        class: "Monk",
        level: 3
      },
      'oath_of_conquest': {
        name: "Oath of Conquest",
        description: "Paladin: Crush enemies completely, rule through fear and overwhelming force.",
        class: "Paladin",
        level: 3
      },
      'oath_of_redemption': {
        name: "Oath of Redemption",
        description: "Paladin: Peace and forgiveness over violence, protect and redeem rather than destroy.",
        class: "Paladin",
        level: 3
      },
      'gloom_stalker': {
        name: "Gloom Stalker",
        description: "Ranger: Master of darkness, invisible to darkvision, extra attack on first turn.",
        class: "Ranger",
        level: 3
      },
      'horizon_walker': {
        name: "Horizon Walker",
        description: "Ranger: Guard against planar threats, teleport and convert damage to force.",
        class: "Ranger",
        level: 3
      },
      'monster_slayer': {
        name: "Monster Slayer",
        description: "Ranger: Dedicated to hunting specific creatures, study and counter their abilities.",
        class: "Ranger",
        level: 3
      },
      'inquisitive': {
        name: "Inquisitive",
        description: "Rogue: Master detective, see through lies and study enemies for sneak attack.",
        class: "Rogue",
        level: 3
      },
      'mastermind': {
        name: "Mastermind",
        description: "Rogue: Master manipulator, grant advantage as bonus action from 30 feet.",
        class: "Rogue",
        level: 3
      },
      'scout': {
        name: "Scout",
        description: "Rogue: Swift and skilled in wilderness, move as reaction when enemies approach.",
        class: "Rogue",
        level: 3
      },
      'swashbuckler': {
        name: "Swashbuckler",
        description: "Rogue: Daring and mobile, sneak attack in one-on-one combat, free disengages.",
        class: "Rogue",
        level: 3
      },
      'divine_soul': {
        name: "Divine Soul",
        description: "Sorcerer: Blessed with divine magic, learn cleric spells and gain healing abilities.",
        class: "Sorcerer",
        level: 1
      },
      'shadow_magic': {
        name: "Shadow Magic",
        description: "Sorcerer: Touched by Shadowfell, summon hound of ill omen, walk through walls.",
        class: "Sorcerer",
        level: 1
      },
      'storm_sorcery': {
        name: "Storm Sorcery",
        description: "Sorcerer: Magic of wind and weather, fly when casting spells, immunity to thunder and lightning.",
        class: "Sorcerer",
        level: 1
      },
      'the_celestial': {
        name: "The Celestial",
        description: "Warlock Patron: Bound to celestial being, healing light and radiant damage.",
        class: "Warlock",
        level: 1
      },
      'the_hexblade': {
        name: "The Hexblade",
        description: "Warlock Patron: Sentient weapon grants power, use Charisma for attacks, curse enemies.",
        class: "Warlock",
        level: 1
      },
      'war_magic': {
        name: "War Magic",
        description: "Wizard: Blend evocation and abjuration, tactical wit and arcane deflection.",
        class: "Wizard",
        level: 2
      }
    },
    // [PHASE 0.4 - NOV 15, 2025]: Xanathar's Guide to Everything Subclasses
    // [WHY]: User reported "none of the extra warlock subclasses are appearing in the system"
    // [MIGRATION]: From srdCharacterData.js TODO comments to sources system
    // [TOTAL]: 29 subclasses across 11 classes
    subclasses: {
      // BARBARIAN (3 subclasses)
      'path_of_the_ancestral_guardian': {
        name: 'Path of the Ancestral Guardian',
        class: 'Barbarian',
        source: 'xanathars',
        level: 3,
        description: 'Some barbarians hail from cultures that revere their ancestors. These tribes teach that warriors of the past linger in the world as spirits.',
        features: {
          3: ['Ancestral Protectors'],
          6: ['Spirit Shield'],
          10: ['Consult the Spirits'],
          14: ['Vengeful Ancestors']
        }
      },
      'path_of_the_storm_herald': {
        name: 'Path of the Storm Herald',
        class: 'Barbarian',
        source: 'xanathars',
        level: 3,
        description: 'Filled with a rage that channels primal magic, storm heralds create powerful magical effects emanating from you.',
        features: {
          3: ['Storm Aura'],
          6: ['Storm Soul'],
          10: ['Shielding Storm'],
          14: ['Raging Storm']
        }
      },
      'path_of_the_zealot': {
        name: 'Path of the Zealot',
        class: 'Barbarian',
        source: 'xanathars',
        level: 3,
        description: 'Fueled by a religious fury, zealots are warriors who channel their rage into powerful displays of divine power.',
        features: {
          3: ['Divine Fury', 'Warrior of the Gods'],
          6: ['Fanatical Focus'],
          10: ['Zealous Presence'],
          14: ['Rage Beyond Death']
        }
      },
      // BARD (3 subclasses)
      'college_of_glamour': {
        name: 'College of Glamour',
        class: 'Bard',
        source: 'xanathars',
        level: 3,
        description: 'Tap into the beguiling magic of the Feywild. Your performances captivate and mystify, weaving fey magic into your words and music.',
        features: {
          3: ['Mantle of Inspiration', 'Enthralling Performance'],
          6: ['Mantle of Majesty'],
          14: ['Unbreakable Majesty']
        }
      },
      'college_of_swords': {
        name: 'College of Swords',
        class: 'Bard',
        source: 'xanathars',
        level: 3,
        description: 'Entertain through daring feats of weapon prowess. Blades swirl around you, and you dazzle your foes with your weapon and wit.',
        features: {
          3: ['Bonus Proficiencies', 'Fighting Style', 'Blade Flourish'],
          6: ['Extra Attack'],
          14: ['Master\'s Flourish']
        }
      },
      'college_of_whispers': {
        name: 'College of Whispers',
        class: 'Bard',
        source: 'xanathars',
        level: 3,
        description: 'Use knowledge of people to manipulate and terrify. You learn to infuse your words with frightening magic.',
        features: {
          3: ['Psychic Blades', 'Words of Terror'],
          6: ['Mantle of Whispers'],
          14: ['Shadow Lore']
        }
      },
      // CLERIC (2 subclasses)
      'forge_domain': {
        name: 'Forge Domain',
        class: 'Cleric',
        source: 'xanathars',
        level: 1,
        description: 'Serve deities of the forge and creation. You can bless weapons and armor, transforming mundane items into magical ones.',
        domainSpells: {
          1: ['Identify', 'Searing Smite'],
          3: ['Heat Metal', 'Magic Weapon'],
          5: ['Elemental Weapon', 'Protection from Energy'],
          7: ['Fabricate', 'Wall of Fire'],
          9: ['Animate Objects', 'Creation']
        },
        features: {
          1: ['Bonus Proficiencies', 'Blessing of the Forge'],
          2: ['Channel Divinity: Artisan\'s Blessing'],
          6: ['Soul of the Forge'],
          8: ['Divine Strike'],
          17: ['Saint of Forge and Fire']
        }
      },
      'grave_domain': {
        name: 'Grave Domain',
        class: 'Cleric',
        source: 'xanathars',
        level: 1,
        description: 'Walk the line between life and death. You keep the balance, denying undeath and preserving the sanctity of death.',
        domainSpells: {
          1: ['Bane', 'False Life'],
          3: ['Gentle Repose', 'Ray of Enfeeblement'],
          5: ['Revivify', 'Vampiric Touch'],
          7: ['Blight', 'Death Ward'],
          9: ['Antilife Shell', 'Raise Dead']
        },
        features: {
          1: ['Circle of Mortality', 'Eyes of the Grave'],
          2: ['Channel Divinity: Path to the Grave'],
          6: ['Sentinel at Death\'s Door'],
          8: ['Potent Spellcasting'],
          17: ['Keeper of Souls']
        }
      },
      // DRUID (2 subclasses)
      'circle_of_dreams': {
        name: 'Circle of Dreams',
        class: 'Druid',
        source: 'xanathars',
        level: 2,
        description: 'Druids who are members of the Circle of Dreams hail from regions that have strong ties to the Feywild. You mend wounds and bring joy.',
        features: {
          2: ['Balm of the Summer Court'],
          6: ['Hearth of Moonlight and Shadow'],
          10: ['Hidden Paths'],
          14: ['Walker in Dreams']
        }
      },
      'circle_of_the_shepherd': {
        name: 'Circle of the Shepherd',
        class: 'Druid',
        source: 'xanathars',
        level: 2,
        description: 'Commune with the spirits of nature. You can summon nature spirits to aid you and your allies.',
        features: {
          2: ['Speech of the Woods', 'Spirit Totem'],
          6: ['Mighty Summoner'],
          10: ['Guardian Spirit'],
          14: ['Faithful Summons']
        }
      },
      // FIGHTER (3 subclasses)
      'arcane_archer': {
        name: 'Arcane Archer',
        class: 'Fighter',
        source: 'xanathars',
        level: 3,
        description: 'Employ magic to learn an assortment of supernatural arrows that can seek foes, explode, or distract enemies.',
        features: {
          3: ['Arcane Archer Lore', 'Arcane Shot'],
          7: ['Magic Arrow', 'Curving Shot'],
          10: ['Arcane Shot (2 options)'],
          15: ['Ever-Ready Shot'],
          18: ['Arcane Shot (3 options)']
        }
      },
      'cavalier': {
        name: 'Cavalier',
        class: 'Fighter',
        source: 'xanathars',
        level: 3,
        description: 'Emulate the ideals of a mounted knight. You excel at mounted combat and protecting allies.',
        features: {
          3: ['Bonus Proficiency', 'Born to the Saddle', 'Unwavering Mark'],
          7: ['Warding Maneuver'],
          10: ['Hold the Line'],
          15: ['Ferocious Charger'],
          18: ['Vigilant Defender']
        }
      },
      'samurai': {
        name: 'Samurai',
        class: 'Fighter',
        source: 'xanathars',
        level: 3,
        description: 'Combine resilience with courtly elegance. You can push through any hardship with supernatural focus.',
        features: {
          3: ['Bonus Proficiency', 'Fighting Spirit'],
          7: ['Elegant Courtier'],
          10: ['Tireless Spirit'],
          15: ['Rapid Strike'],
          18: ['Strength Before Death']
        }
      },
      // MONK (3 subclasses)
      'way_of_the_drunken_master': {
        name: 'Way of the Drunken Master',
        class: 'Monk',
        source: 'xanathars',
        level: 3,
        description: 'Learn to move with the jerky, unpredictable movements of a drunkard. You sway, bob, and weave to evade attacks.',
        features: {
          3: ['Bonus Proficiencies', 'Drunken Technique'],
          6: ['Tipsy Sway'],
          11: ['Drunkard\'s Luck'],
          17: ['Intoxicated Frenzy']
        }
      },
      'way_of_the_kensei': {
        name: 'Way of the Kensei',
        class: 'Monk',
        source: 'xanathars',
        level: 3,
        description: 'Train relentlessly with weapons, to the point they become extensions of your body. You turn weapons into monk weapons.',
        features: {
          3: ['Path of the Kensei', 'Kensei Weapons'],
          6: ['One with the Blade'],
          11: ['Sharpen the Blade'],
          17: ['Unerring Accuracy']
        }
      },
      'way_of_the_sun_soul': {
        name: 'Way of the Sun Soul',
        class: 'Monk',
        source: 'xanathars',
        level: 3,
        description: 'Learn to channel your own life energy into searing bolts of light. You hurl magic projectiles and create devastating bursts.',
        features: {
          3: ['Radiant Sun Bolt'],
          6: ['Searing Arc Strike'],
          11: ['Searing Sunburst'],
          17: ['Sun Shield']
        }
      },
      // PALADIN (2 subclasses)
      'oath_of_conquest': {
        name: 'Oath of Conquest',
        class: 'Paladin',
        source: 'xanathars',
        level: 3,
        description: 'Seek glory in battle and the subjugation of your enemies. You bring despair to your foes and inspire fear in all who oppose you.',
        oathSpells: {
          3: ['Armor of Agathys', 'Command'],
          5: ['Hold Person', 'Spiritual Weapon'],
          9: ['Bestow Curse', 'Fear'],
          13: ['Dominate Beast', 'Stoneskin'],
          17: ['Cloudkill', 'Dominate Person']
        },
        features: {
          3: ['Channel Divinity: Conquering Presence', 'Channel Divinity: Guided Strike'],
          7: ['Aura of Conquest'],
          15: ['Scornful Rebuke'],
          20: ['Invincible Conqueror']
        }
      },
      'oath_of_redemption': {
        name: 'Oath of Redemption',
        class: 'Paladin',
        source: 'xanathars',
        level: 3,
        description: 'Believe that anyone can be redeemed. You use violence only as a last resort, preferring to deflect attacks and protect the weak.',
        oathSpells: {
          3: ['Sanctuary', 'Sleep'],
          5: ['Calm Emotions', 'Hold Person'],
          9: ['Counterspell', 'Hypnotic Pattern'],
          13: ['Otiluke\'s Resilient Sphere', 'Stoneskin'],
          17: ['Hold Monster', 'Wall of Force']
        },
        features: {
          3: ['Channel Divinity: Emissary of Peace', 'Channel Divinity: Rebuke the Violent'],
          7: ['Aura of the Guardian'],
          15: ['Protective Spirit'],
          20: ['Emissary of Redemption']
        }
      },
      // RANGER (3 subclasses)
      'gloom_stalker': {
        name: 'Gloom Stalker',
        class: 'Ranger',
        source: 'xanathars',
        level: 3,
        description: 'At home in the darkest places. You ambush enemies from the shadows, moving with supernatural stealth.',
        features: {
          3: ['Dread Ambusher', 'Umbral Sight', 'Gloom Stalker Magic'],
          7: ['Iron Mind'],
          11: ['Stalker\'s Flurry'],
          15: ['Shadowy Dodge']
        }
      },
      'horizon_walker': {
        name: 'Horizon Walker',
        class: 'Ranger',
        source: 'xanathars',
        level: 3,
        description: 'Guard the world against threats from other planes. You learn to teleport and strike foes from multiple planes at once.',
        features: {
          3: ['Detect Portal', 'Planar Warrior', 'Horizon Walker Magic'],
          7: ['Ethereal Step'],
          11: ['Distant Strike'],
          15: ['Spectral Defense']
        }
      },
      'monster_slayer': {
        name: 'Monster Slayer',
        class: 'Ranger',
        source: 'xanathars',
        level: 3,
        description: 'Specialize in hunting down creatures of evil. You learn supernatural defenses and can turn enemies\' strengths against them.',
        features: {
          3: ['Hunter\'s Sense', 'Slayer\'s Prey', 'Monster Slayer Magic'],
          7: ['Supernatural Defense'],
          11: ['Magic-User\'s Nemesis'],
          15: ['Slayer\'s Counter']
        }
      },
      // ROGUE (4 subclasses)
      'inquisitive': {
        name: 'Inquisitive',
        class: 'Rogue',
        source: 'xanathars',
        level: 3,
        description: 'Excel at rooting out secrets and unraveling mysteries. Your keen eye for detail makes you an exceptional investigator.',
        features: {
          3: ['Ear for Deceit', 'Eye for Detail', 'Insightful Fighting'],
          9: ['Steady Eye'],
          13: ['Unerring Eye'],
          17: ['Eye for Weakness']
        }
      },
      'mastermind': {
        name: 'Mastermind',
        class: 'Rogue',
        source: 'xanathars',
        level: 3,
        description: 'Master of intrigue. You excel at deception, manipulation, and gathering intelligence.',
        features: {
          3: ['Master of Intrigue', 'Master of Tactics'],
          9: ['Insightful Manipulator'],
          13: ['Misdirection'],
          17: ['Soul of Deceit']
        }
      },
      'scout': {
        name: 'Scout',
        class: 'Rogue',
        source: 'xanathars',
        level: 3,
        description: 'Skilled hunter and tracker. You excel at hit-and-run tactics and can move quickly through difficult terrain.',
        features: {
          3: ['Skirmisher', 'Survivalist'],
          9: ['Superior Mobility'],
          13: ['Ambush Master'],
          17: ['Sudden Strike']
        }
      },
      'swashbuckler': {
        name: 'Swashbuckler',
        class: 'Rogue',
        source: 'xanathars',
        level: 3,
        description: 'Charming combatant who excels in one-on-one combat. You blend speed, elegance, and charm into a deadly fighting style.',
        features: {
          3: ['Fancy Footwork', 'Rakish Audacity'],
          9: ['Panache'],
          13: ['Elegant Maneuver'],
          17: ['Master Duelist']
        }
      },
      // SORCERER (3 subclasses)
      'divine_soul': {
        name: 'Divine Soul',
        class: 'Sorcerer',
        source: 'xanathars',
        level: 1,
        description: 'Your innate magic comes from a divine source. You can channel both arcane and divine magic.',
        features: {
          1: ['Divine Magic', 'Favored by the Gods'],
          6: ['Empowered Healing'],
          14: ['Otherworldly Wings'],
          18: ['Unearthly Recovery']
        }
      },
      'shadow_magic': {
        name: 'Shadow Magic',
        class: 'Sorcerer',
        source: 'xanathars',
        level: 1,
        description: 'Your innate magic comes from the Shadowfell. You can manipulate shadows and darkness, and even cheat death.',
        features: {
          1: ['Eyes of the Dark', 'Strength of the Grave'],
          6: ['Hound of Ill Omen'],
          14: ['Shadow Walk'],
          18: ['Umbral Form']
        }
      },
      'storm_sorcery': {
        name: 'Storm Sorcery',
        class: 'Sorcerer',
        source: 'xanathars',
        level: 1,
        description: 'Your innate magic comes from the power of elemental air. You can fly on the winds and call upon storms.',
        features: {
          1: ['Wind Speaker', 'Tempestuous Magic'],
          6: ['Heart of the Storm', 'Storm Guide'],
          14: ['Storm\'s Fury'],
          18: ['Wind Soul']
        }
      },
      // WARLOCK (2 subclasses)
      'the_celestial': {
        name: 'The Celestial',
        class: 'Warlock',
        source: 'xanathars',
        level: 1,
        description: 'Your patron is a powerful being from the Upper Planes. You gain healing abilities and radiant power.',
        expandedSpellList: {
          1: ['Cure Wounds', 'Guiding Bolt'],
          3: ['Flaming Sphere', 'Lesser Restoration'],
          5: ['Daylight', 'Revivify'],
          7: ['Guardian of Faith', 'Wall of Fire'],
          9: ['Flame Strike', 'Greater Restoration']
        },
        features: {
          1: ['Bonus Cantrips', 'Healing Light'],
          6: ['Radiant Soul'],
          10: ['Celestial Resilience'],
          14: ['Searing Vengeance']
        }
      },
      'the_hexblade': {
        name: 'The Hexblade',
        class: 'Warlock',
        source: 'xanathars',
        level: 1,
        description: 'Your patron is a mysterious entity from the Shadowfell. You gain the ability to curse your foes and wield weapons with supernatural skill.',
        expandedSpellList: {
          1: ['Shield', 'Wrathful Smite'],
          3: ['Blur', 'Branding Smite'],
          5: ['Blink', 'Elemental Weapon'],
          7: ['Phantasmal Killer', 'Staggering Smite'],
          9: ['Banishing Smite', 'Cone of Cold']
        },
        features: {
          1: ['Hexblade\'s Curse', 'Hex Warrior'],
          6: ['Accursed Specter'],
          10: ['Armor of Hexes'],
          14: ['Master of Hexes']
        }
      }
    },
    backgrounds: {},
    boons: {}
  }
};